/*
 * @Author: bbqin
 * @Date: 2022-11-16 15:13:19
 * @LastEditTime: 2022-11-16 17:28:56
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TransferTable\cell.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, cloneElement } from "react";
import { itemCreator } from "@platform/template";

class Cell extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {

    }

    render() {

        const { item, record, index, scale, itemtype, value, onAfterEvent, onCellBowse } = this.props;

        const { attrcode, hintmessage, maxlength, placeholder, disabled, ...others } = item;
        const rowKeyValue = record.key || record.rowId;
        const values = record.values || record;
        const currentCell = values[attrcode];
        let display = currentCell.display;
        let cellValue = currentCell.value;
        // 记录旧值
        this.oldValue = this.oldValue || {
            display,
            value: cellValue,
        };

        const propsToPass = {
            ...others,
            open: true,
            autoShow: true,
            record: record,
            rowIndex: index,
            isCheckChinese: !!maxlength,
            maxlength: maxlength,
            renderInTable: true,
            disabled: disabled,
            scale: scale,
            browse: false,
            itemtype: itemtype,
            attrcode: attrcode,
            setFieldValue: ({ value, attrcode, componentValue }) => {
                let filedValue;
                // 处理参照值 
                if (itemtype === 'refer') {
                    filedValue = { ...value, ...componentValue }
                } else {
                    filedValue = value
                }
                // 供应链换算率 建议移除 不应该加载组件内部
                if (itemtype === 'input' && ['vchangerate', 'vqtunitrate'].includes(attrcode)) {
                    let reg = /^[0-9\/\.]+$/;
                    if (filedValue?.value && !reg.test(filedValue.value)) { //只能输入数字和/
                        return;
                    }
                }

                if (!currentCell) {
                    console.log('未找到对应的单元格');
                }

                // 赋值
                currentCell.display = filedValue.display;
                currentCell.value = filedValue.value;

                // input类型更新
                if (itemtype === 'input') {
                    this.forceUpdate();
                }
            },
            getFieldValue: () => {
                return {
                    display: currentCell.display,
                    value: currentCell.value,
                };
            },
            onAfterEvent: ({ value, oldValue, componentValue }) => {
                currentCell.isEdit = false;
                const currentValue = itemtype == 'refer' ? { ...value, ...componentValue } : value;
                onAfterEvent({ attrcode, currentValue, record, index, oldValue, itemtype });
            },
            path: [rowKeyValue, attrcode],
            // 自定义单元格
            renderItem: this.renderItem,
            // placeholder
            placeholder: hintmessage || placeholder,
        }

        const itemConfig = itemCreator(propsToPass);

        let {
            afterEventTrigger,
            valueChangePropName,
            valuePropName,
            component,
            fieldValueToComponentValue,
            getFieldValue,
            normalize,
            componentValueToFieldValue,
            setFieldValue,
        } = itemConfig;

        let fieldValue = getFieldValue({ attrcode });
        let componentValue = fieldValueToComponentValue(fieldValue);

        const afterEventHandler = (...rest) => {
            if (this.dirty) {
                this.dirty = false;
                let fieldValue = getFieldValue({ attrcode });
                let componentValue = fieldValueToComponentValue(fieldValue);

                let eventFromArgs = rest.find(e => e && typeof e.preventDefault === 'function'),
                    eventFromWindow = window.event,
                    defaultEvent = {
                        stopPropagation() {
                            console.warn('未找到Event对象');
                        },
                        preventDefault() {
                            console.warn('未找到Event对象');
                        },
                    };

                const event = eventFromArgs || eventFromWindow || defaultEvent;

                propsToPass.onAfterEvent({
                    value: fieldValue,
                    oldValue: this.oldValue,
                    componentValue: componentValue,
                    event,
                });

                this.oldValue = null;
            } else {
                currentCell.isEdit = false;
                onCellBowse();
            }
        }

        return component ? cloneElement(component, {
            ...propsToPass,
            onBlur: () => {
                currentCell.isEdit = false;
                onCellBowse();
            },
            [afterEventTrigger]: afterEventHandler.bind(this),
            [valueChangePropName]: (...rest) => {
                const currentValue = normalize(...rest);
                let value = componentValueToFieldValue(currentValue);
                this.dirty = true;

                setFieldValue({
                    attrcode,
                    value,
                    componentValue: currentValue,
                });

                if (afterEventTrigger === valueChangePropName) {
                    afterEventHandler.call(this, ...rest);
                }
            },
            [valuePropName]: componentValue,
            autoFocus: true,
            // chrome下使用disabled的实现方式，其余浏览器用mousedown的实现方式
            disabled: disabled,
        }) : <span>{value}</span>;
    }
}

export default Cell;